<div class="pagination" *ngIf="total>0">
    <span>Showing {{(currentPage-1) * pageSize + 1}} to {{((currentPage-1) * pageSize + pageSize) > total ? total :
        ((currentPage-1) * pageSize + pageSize)}} of {{total}}</span>
    <div>
        <li *ngFor="let page of pages; index as i">
            <a class="p-btn font-weight-bold" [class.active]="page === currentPage"
                [style.color]="page === currentPage ? 'white' : 'grey'" (click)="changePage(page,i)">
                {{page === -1 ? '...' : page}}
            </a>
        </li>
    </div>
</div>